export default () => {

    const products = () => {
        const products = document.querySelectorAll(".products .product");

        if (products) {
            products.forEach((product => {

                const pName = product.querySelector(".p-in-in");
                const pFlagDiscount = product.querySelector(".flags.flags-extra .flag-discount");
                const productPrices = product.querySelector('.p-bottom .prices');

                if (pFlagDiscount && productPrices) {
                    pFlagDiscount.classList.add('is-hide');

                    const priceBeforeDiscount = pFlagDiscount.querySelector('.price-standard');

                    if (priceBeforeDiscount) {
                        productPrices.insertAdjacentHTML('beforeend', `
                            <div class="price price-beforeDiscount">
                                <span class="bold">
                                    ${priceBeforeDiscount.innerHTML}
                                </span>
                            </div>
                        `)
                    }
                }
            }))
        }
    }

    products()

    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        products();
    });


};